import {Box, Container, Typography} from "@mui/material";
import {type JSX, useEffect, useState} from "react";
import {PreviousOrderCard} from "@/components/Cart/PreviousOrderCard.tsx";
import {useUser} from "@/components/Providers/JWTProvider.tsx";
import StandardPage from "@/components/StandardPage";
import NotFound from "@/pages/NotFound.tsx";

export type CartListing = {
    id: string;
    paidCents: number;
    updatedAt: string;
    cartItemsCount: number;
    glenbrookPaymentId: string | null;
    paymentType: string | null;
    transactionId: string | null;
    itemCount: number;
};

const CartHistoryPage = (): JSX.Element => {
    const {user} = useUser();
    const [pastCarts, setPastCarts] = useState<CartListing[]>([]);

    useEffect(() => {
        if (!user?.apiFetch) {
            return;
        }
        const url = new URL("/v1/cart/history", import.meta.env.VITE_APP_API_ENDPOINT);
        user.apiFetch(url).then(async response => {
            const responseData = (await response.json()) as CartListing[];
            setPastCarts(responseData);
        });
    }, [user?.apiFetch]);

    if (!user) {
        return <NotFound />;
    }
    return (
        <StandardPage>
            <Container maxWidth="lg" sx={{py: 4}}>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        mb: 4,
                    }}
                >
                    <Typography variant="h5" color="primary">
                        Purchase History
                    </Typography>
                </Box>

                <Box
                    sx={{
                        height: "calc(100vh - 200px)",
                        overflowY: "auto",
                        pr: 2,
                        mr: -2,
                    }}
                >
                    {pastCarts?.map(order => (
                        <PreviousOrderCard key={order.id} order={order} />
                    ))}
                    {pastCarts?.length === 0 && (
                        <Box sx={{textAlign: "center", py: 4, color: "text.secondary"}}>
                            No previous Purchases found
                        </Box>
                    )}
                </Box>
            </Container>
        </StandardPage>
    );
};

export default CartHistoryPage;
